import React, { forwardRef } from 'react';
import { useIntl } from 'react-intl';
import minusCirclePath from '@starbucks-web/pattern-library/lib/icons/minus-circle';
import minusCircleSolidPath from '@starbucks-web/pattern-library/lib/icons/minus-circle-solid';

import StepperIconButton from './stepper-icon-button';
import messages from './messages';

const MinusButton = forwardRef(
  (
    {
      ariaDescribedBy,
      currentQuantity,
      modifiedFromDefault,
      onClick = () => {},
      onValueChange,
    },
    ref
  ) => {
    const { formatMessage } = useIntl();
    const decreaseQuantity = () => {
      onValueChange?.(currentQuantity - 1);
      onClick();
    };
    return (
      <StepperIconButton
        ariaDescribedBy={ariaDescribedBy}
        ariaLabel={formatMessage(messages.decreaseQuantityMessage)}
        onClick={decreaseQuantity}
        path={modifiedFromDefault ? minusCircleSolidPath : minusCirclePath}
        ref={ref}
      />
    );
  }
);

export default MinusButton;
